export default "__VITE_ASSET__Dsu9mOos__"